<template>
  <label
    :class="[
      'checkbox-container',
      { 'disabled-element': disabled, 'deactived-element': deactived },
    ]"
  >
    <input
      type="checkbox"
      ref="input"
      :disabled="disabled || deactived"
      :checked="checked && !disabled"
      @change="toggle"
    />
    <div class="checkbox-restyle" />
  </label>
</template>
<script>
export default {
  name: 'CheckBox',
  props: {
    checked: {
      type: [Boolean, Number],
      default: 0,
    },
    disabled: {
      type: Boolean,
    },
    deactived: {
      type: Boolean,
    },
  },
  methods: {
    toggle() {
      if (this.disabled || this.deactived) return;
      this.$refs.input.checked = this.checked;
      this.$emit('change', Number(!this.checked));
      this.$emit('input', Boolean(!this.checked));
    },
  },
};
</script>
<style scoped>
.checkbox-container {
  vertical-align: middle;
  display: inline-block;
}

input[type='checkbox'] {
  display: none;
}

input[type='checkbox'] ~ .checkbox-restyle:after {
  left: 0.5em;
  top: 0.1em;
  width: 0.4em;
  height: 0.8em;
  border: solid #fff;
  border-width: 0 0.2em 0.2em 0;
  transform: rotate(45deg);
}

input[type='checkbox']:checked ~ .checkbox-restyle {
  background-color: #ed7e57;
  transition: 0.3s ease-out;
}

input[type='checkbox']:checked ~ .checkbox-restyle:after {
  display: block;
}

.checkbox-restyle {
  position: relative;
  height: 1.5em;
  width: 1.5em;

  box-shadow: 0 0 0 1px #c3c7cc;
  background-color: #f2f2f2;
  cursor: pointer;
}

.checkbox-restyle:after {
  content: '';
  position: absolute;
  display: none;
}

.checkbox-restyle:hover {
  background-color: #ddd;
}

.disabled-element,
.deactived-element {
  pointer-events: none;
}

.disabled-element .checkbox-restyle,
.deactived-element .checkbox-restyle {
  cursor: default;
}

.disabled-element input[type='checkbox'] ~ .checkbox-restyle {
  background-color: #ddd;
  box-shadow: 0 0 0 1px #ddd;
}
</style>
